<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createContenidoNodo"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionMapPathModalCreatePath.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="nodo.nodo.nombre"
          :inputError="$v.nodo.nodo.nombre.$error"
          :label="$t('mEditionMapPathModalCreatePath.inputs.nombre.label')"
          :messageError="messageErrorNombre"
          name="nombre"
          type="text"
          @blur="$v.nodo.nodo.nombre.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionMapPathModalCreatePath.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionMapPathModalCreatePath',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionMapPathModalCreatePath.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      nodo: {
        academia: 0,
        proyecto: 0,
        nodo: {
          color: '#ffffff',
          descripcion: '',
          nombre: '',
          padre: '',
          titulo: ''
        }
      }
    }
  },

  validations: {
    nodo: {
      nodo: {
        nombre: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        }
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionMapPathModalCreatePath', this.$v.nodo.nodo.nombre, 'nodo', 'nombre')
    }
  },

  watch: {
    'nodo.nodo.nombre' () {
      this.nodo.nodo.titulo = this.nodo.nodo.nombre
    }
  },

  created () {
    this.nodo.academia = this.$store.getters.getAcademyData.id
    this.nodo.proyecto = this.$route.params.id
    let GroupA = [1, 6, 11, 16, 21, 26]
    let GroupB = [2, 7, 12, 17, 22]
    let GroupC = [3, 8, 13, 18, 23]
    let GroupD = [4, 9, 14, 19, 24]
    let GroupE = [0, 5, 10, 15, 20, 25]
    let numberNodes = this.$store.getters.getAssetNodes.length + 1
    numberNodes = parseInt(numberNodes.toString().split('')[numberNodes.toString().split('').length - 1])
    if (GroupA.includes(numberNodes)) {
      this.nodo.nodo.color = '#a9da65'
    }
    if (GroupB.includes(numberNodes)) {
      this.nodo.nodo.color = '#ef9853'
    }
    if (GroupC.includes(numberNodes)) {
      this.nodo.nodo.color = '#7db5dd'
    }
    if (GroupD.includes(numberNodes)) {
      this.nodo.nodo.color = '#fece65'
    }
    if (GroupE.includes(numberNodes)) {
      this.nodo.nodo.color = '#c98bc3'
    }
  },

  methods: {
    createContenidoNodo () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('contenido', 'createContenidoNodo', this.nodo, [this.$modal.element.id])
          .then(response => {
            let newNode = Object.assign({}, response.data)
            newNode.children = []
            this.$store.commit('setAssetSelectedNode', newNode)
            this.$modal.updateData('readElement')
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionMapPathModalCreatePath', 'createContenidoNodo', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionMapPathModalCreatePath', 'createContenidoNodo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
